import React from 'react';
import {
  Bell, Video, Shield, Gift, Scissors, Camera, UserCog, Lock,
  Smartphone, Mail, Sparkles, Map as MapIcon
} from 'lucide-react';
import api from '../api';

export const formatRelativeTime = (ts) => {
  const d = ts ? new Date(ts.replace(' ', 'T')) : new Date();
  const timestamp = d.getTime();
  if (isNaN(timestamp)) return '';
  const diff = Date.now() - timestamp;
  if (diff < 60000) return '刚刚';
  if (diff < 3600000) return Math.floor(diff / 60000) + '分钟前';
  if (diff < 86400000) return Math.floor(diff / 3600000) + '小时前';
  if (diff < 604800000) return Math.floor(diff / 86400000) + '天前';
  return d.toLocaleDateString('zh-CN');
};

export const formatExactTime = (ts) => {
  const d = ts ? new Date(ts.replace(' ', 'T')) : new Date();
  if (isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const playNotificationSound = (notifSoundEnabled, getAudioContext) => {
  if (!notifSoundEnabled) return;
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;
    const t1 = ctx.createOscillator(), g1 = ctx.createGain();
    t1.type = 'sine'; t1.frequency.setValueAtTime(784, now);
    g1.gain.setValueAtTime(0.25, now); g1.gain.exponentialRampToValueAtTime(0.001, now + 0.18);
    t1.connect(g1); g1.connect(ctx.destination);
    t1.start(now); t1.stop(now + 0.2);

    const t2 = ctx.createOscillator(), g2 = ctx.createGain();
    t2.type = 'sine'; t2.frequency.setValueAtTime(1047, now + 0.16);
    g2.gain.setValueAtTime(0, now); g2.gain.linearRampToValueAtTime(0.22, now + 0.17); g2.gain.exponentialRampToValueAtTime(0.001, now + 0.55);
    t2.connect(g2); g2.connect(ctx.destination);
    t2.start(now + 0.16); t2.stop(now + 0.58);
  } catch (e) {}
};

export const markNotificationRead = (notifId, source, setGlobalNotifications, setNotifUnreadCount) => {
  api.notification.markRead(notifId, source).then(() => {
    setGlobalNotifications(prev => prev.map(n => n.id === notifId ? { ...n, is_read: 1, read: true } : n));
    setNotifUnreadCount(prev => Math.max(0, prev - 1));
  }).catch(() => {});
};

export const renderNotifIcon = (iconName, size = 'w-5 h-5') => {
  const iconProps = { className: size };
  switch (iconName) {
    case 'Bell': return <Bell {...iconProps} />;
    case 'Video': return <Video {...iconProps} />;
    case 'Shield': return <Shield {...iconProps} />;
    case 'Gift': return <Gift {...iconProps} />;
    case 'Scissors': return <Scissors {...iconProps} />;
    case 'Camera': return <Camera {...iconProps} />;
    case 'UserCog': return <UserCog {...iconProps} />;
    case 'Lock': return <Lock {...iconProps} />;
    case 'Smartphone': return <Smartphone {...iconProps} />;
    case 'Mail': return <Mail {...iconProps} />;
    case 'Sparkles': return <Sparkles {...iconProps} />;
    case 'Map': return <MapIcon {...iconProps} />;
    default: return <Bell {...iconProps} />;
  }
};
